import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import { changeToSettingMode } from '../../../js/actions/appModeActionCreators';
import Intro from './Intro';
import { fetchPermissions } from '../../../js/actions/permissionsActionCreators';
import { updateStatuses } from '../../../js/statuses';
import permissionLevel from '../../../js/permissionLevel';
import { getAppliedPermission } from '../../../js/projections/permissions';
import PermissionsForm from './PermissionsForm';

const mode = {
    view: 'view',
    edit: 'edit'
};

const PermissionsPage = React.createClass({
    propTypes: {
        isReady: PropTypes.bool.isRequired,
        appliedPermission: PropTypes.shape({
            permissionLevel: PropTypes.oneOf(_(permissionLevel).values()).isRequired,
            groupName: PropTypes.string
        }),
        initialFormValues: PropTypes.object,
        alignMode: PropTypes.func.isRequired,
        onMount: PropTypes.func.isRequired
    },
    getInitialState: function() {
        return {
            mode: mode.view
        };
    },
    componentDidMount: function () {
        this.props.alignMode();
    },
    componentWillMount: function() {
        this.props.onMount();
    },
    changeToEditMode: function() {
        this.setState({
            mode: mode.edit
        });
    },
    changeToViewMode: function() {
        this.setState({
            mode: mode.view
        });
    },
    render: function () {
        const { appliedPermission, isReady, initialFormValues } = this.props;
        const isGroupBased = isReady ? appliedPermission.permissionLevel === permissionLevel.groupBased : null;

        return <div>
            
            <Intro />
            <hr/>

            {isReady && <div>
                
                {this.state.mode === mode.view && <div>
                    {!isGroupBased && <div>
                        <p>Everyone in your organization can use SQL Clone.</p>
                    </div>}

                    {isGroupBased && <div>
                        <p>Anyone in this user group can use SQL Clone.</p>
                    </div>}

                    <div>
                        <strong>{isGroupBased ? appliedPermission.groupName : 'Everyone'}</strong>
                        <button onClick={this.changeToEditMode} className="button button--primary spaced-left--tight">Change</button>
                    </div>
                </div>}

                {this.state.mode === mode.edit && <PermissionsForm onCancel={this.changeToViewMode} onSuccess={this.changeToViewMode} initialValues={initialFormValues} />}
            </div>}

        </div>;
    }
});

const mapStateToProps = (state) => {
    const isReady = state.permissions.updateStatus == updateStatuses.success;
    let appliedPermission;

    if(isReady) {
        appliedPermission = getAppliedPermission(state);
    }

    return {
        isReady: isReady,
        appliedPermission: appliedPermission,
        initialFormValues: isReady ? {
            levelOfPermission: appliedPermission.permissionLevel,
            nameOfGroup: appliedPermission.groupName
        } : null
    };
};

const mapDispatchToProps = (dispatch) => ({
    alignMode: () => {
        dispatch(changeToSettingMode());
    },
    onMount: () => {
        dispatch(fetchPermissions());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionsPage);



// WEBPACK FOOTER //
// ./src/components/settings/PermissionsPage/index.jsx